module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/250k-inactive-e5f2d0b52a0f0b2bd7f3b6a62d3c331b.png";